import { writable } from "svelte/store";
export const scores = writable([]);
export const points = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    10,
    12
];
export const currentPoints = writable(0);
const countries = [
    { code: "AL", code3: "ALB", name: "Albania", number: "008" },
    { code: "AD", code3: "AND", name: "Andorra", number: "020" },
    { code: "AM", code3: "ARM", name: "Armenia", number: "051" },
    { code: "AU", code3: "AUS", name: "Australia", number: "036" },
    { code: "AT", code3: "AUT", name: "Austria", number: "040" },
    { code: "AZ", code3: "AZE", name: "Azerbaijan", number: "031" },
    { code: "BY", code3: "BLR", name: "Belarus", number: "112" },
    { code: "BE", code3: "BEL", name: "Belgium", number: "056" },
    { code: "BA", code3: "BIH", name: "Bosnia and Herzegovina", number: "070" },
    { code: "BG", code3: "BGR", name: "Bulgaria", number: "100" },
    { code: "HR", code3: "HRV", name: "Croatia", number: "191" },
    { code: "CY", code3: "CYP", name: "Cyprus", number: "196" },
    { code: "CZ", code3: "CZE", name: "Czechia", number: "203" },
    { code: "DK", code3: "DNK", name: "Denmark", number: "208" },
    { code: "EE", code3: "EST", name: "Estonia", number: "233" },
    { code: "FI", code3: "FIN", name: "Finland", number: "246" },
    { code: "GE", code3: "GEO", name: "Georgia", number: "268" },
    { code: "GR", code3: "GRC", name: "Greece", number: "300" },
    { code: "HU", code3: "HUN", name: "Hungary", number: "348" },
    { code: "IS", code3: "ISL", name: "Iceland", number: "352" },
    { code: "IE", code3: "IRL", name: "Ireland", number: "372" },
    { code: "IL", code3: "ISR", name: "Israel", number: "376" },
    { code: "LV", code3: "LVA", name: "Latvia", number: "428" },
    { code: "LB", code3: "LBN", name: "Lebanon", number: "422" },
    { code: "LI", code3: "LIE", name: "Liechtenstein", number: "438" },
    { code: "LT", code3: "LTU", name: "Lithuania", number: "440" },
    { code: "LU", code3: "LUX", name: "Luxembourg", number: "442" },
    { code: "MT", code3: "MLT", name: "Malta", number: "470" },
    { code: "MD", code3: "MDA", name: "Moldova", number: "498" },
    { code: "MC", code3: "MCO", name: "Monaco", number: "492" },
    { code: "ME", code3: "MNE", name: "Montenegro", number: "499" },
    { code: "NL", code3: "NLD", name: "Netherlands", number: "528" },
    { code: "NO", code3: "NOR", name: "Norway", number: "578" },
    { code: "PL", code3: "POL", name: "Poland", number: "616" },
    { code: "PT", code3: "PRT", name: "Portugal", number: "620" },
    { code: "MK", code3: "MKD", name: "North Macedonia", number: "807" },
    { code: "RO", code3: "ROU", name: "Romania", number: "642" },
    { code: "RU", code3: "RUS", name: "Russia", number: "643" },
    { code: "SM", code3: "SMR", name: "San Marino", number: "674" },
    { code: "RS", code3: "SRB", name: "Serbia", number: "688" },
    { code: "SK", code3: "SVK", name: "Slovakia", number: "703" },
    { code: "SI", code3: "SVN", name: "Slovenia", number: "705" },
    { code: "SE", code3: "SWE", name: "Sweden", number: "752" },
    { code: "CH", code3: "CHE", name: "Switzerland", number: "756" },
    { code: "TR", code3: "TUR", name: "Turkey", number: "792" },
    { code: "UA", code3: "UKR", name: "Ukraine", number: "804" },
];
const bigFive = [
    { code: "FR", code3: "FRA", name: "France", number: "250" },
    { code: "DE", code3: "DEU", name: "Germany", number: "276" },
    { code: "IT", code3: "ITA", name: "Italy", number: "380" },
    { code: "ES", code3: "ESP", name: "Spain", number: "724" },
    { code: "GB", code3: "GBR", name: "United Kingdom", number: "826" },
];
const setupCountries = () => {
    const list = [];
    let shuffled = countries.sort(() => 0.5 - Math.random());
    shuffled = [...bigFive, ...shuffled];
    for (let i = 0; i < 26; i++) {
        const country = shuffled[i];
        list.push({
            flag: country.code.toLowerCase(),
            name: country.name,
            points: 0
        });
    }
    scores.set(list);
};
setupCountries();
